// Synchronous projection transactions: subscribers see lifecycle, transcript,
// worker state, and provenance from the same accepted event in one notification.
export function atomicStoreAccess(set, get) {
  let pending = null;
  const read = () => pending || get();
  const write = (patch) => {
    if (!pending) return set(patch);
    const update = typeof patch === "function" ? patch(pending) : patch;
    if (update && Object.keys(update).length) pending = { ...pending, ...update };
  };
  const batch = (action) => {
    if (pending) return action();
    pending = get();
    try {
      const result = action();
      const next = pending;
      pending = null;
      set(next);
      return result;
    } finally { pending = null; }
  };
  return { read, write, batch };
}
